
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/release",
      function () {
        return require("private-next-pages/news/release/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/release"])
      });
    }
  